import React from 'react';
import Header from '../components/Header/Header';
import MediaCenterHero from '../components/MediaCenterHero/MediaCenterHero';
import MiniMultimedia from '../components/MiniMultimedia/MiniMultimedia'; 
import VideoGrid from '../components/VideoGrid/VideoGrid';
import Footer from '../components/Footer/Footer';
import FooterCTA from '../components/FooterCTA/FooterCTA';
const MediaCenterPage = () => {
return (
<>
<Header />
<main>
<MediaCenterHero />
<MiniMultimedia />
<VideoGrid /> 
<FooterCTA />
</main>
<Footer />
</>
);
};
export default MediaCenterPage;